export const messagesByGroup = /* GraphQL */ `
  query MessagesByGroup(
    $group: String
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    messagesByGroup(
        group: $group
        createdAt: $createdAt
        sortDirection: $sortDirection
        filter: $filter
        limit: $limit
        nextToken: $nextToken
    ) {
        items {
            id
            staff {
                id
                firstName
                lastName
                status
            }
            attachment{
              id
              s3Key
              contentType
            }
            attachmentLink
            device {
              id
              deviceName
            }
            channelType
            destinationNumber
            destinationEmail
            subject
            bodyText
            bodyHtml
            smsStatus
            smsSendInformation
            emailStatus
            emailSendInformation
            deviceSmsSendInformation
            deviceSmsStatus
            inAppMessageStatus
            inAppMessageSendInformation
            phoneStatus
            phoneSendInformation
            destinationName
            createdAt
            updatedAt
            messageType
            hasParts
        }
        nextToken
    }
  }
`;
export const messagesByGroupAndMessageType = /* GraphQL */ `
  query MessagesByGroupAndMessageType(
    $group: String
    $messageTypeCreatedAt: ModelMessageByGroupAndMessageTypeCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    messagesByGroupAndMessageType(
      group: $group
      messageTypeCreatedAt: $messageTypeCreatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        staff {
          id
          firstName
          lastName
          status
        }
        attachment {
          id
          s3Key
          contentType
        }
        attachmentLink
        device {
          id
          deviceName
        }
        channelType
        destinationNumber
        destinationEmail
        subject
        bodyText
        bodyHtml
        smsStatus
        smsSendInformation
        emailStatus
        emailSendInformation
        inAppMessageStatus
        inAppMessageSendInformation
        phoneStatus
        phoneSendInformation
        deviceSmsSendInformation
        deviceSmsStatus
        destinationName
        createdAt
        updatedAt
        messageType
        hasParts
      }
      nextToken
      __typename
    }
  }
`;

export const messagesByStaffAndMessageType = /* GraphQL */ `
  query MessagesByStaffAndMessageType(
    $staffId: ID
    $messageTypeCreatedAt: ModelMessageByStaffAndMessageTypeCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    messagesByStaffAndMessageType(
      staffId: $staffId
      messageTypeCreatedAt: $messageTypeCreatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        staff {
          id
          firstName
          lastName
          status
        }
        createdAt
        channelType
        group
        staffId
        subject
        bodyText
        senderName
        smsStatus
        smsSendInformation
        deviceSmsSendInformation
        deviceSmsStatus
        emailStatus
        emailSendInformation
        inAppMessageStatus
        inAppMessageSendInformation
        phoneStatus
        phoneSendInformation
        isReadS
        sender {
          id
        }
        device {
          id
          deviceName
        } 
        messageType
        contentType
        attachment{
          id
          s3Key
          fileSize
          contentType
          expirationDate
          shortenUrl {
            items {
              id
              shortenId
            }
            nextToken
          }
        }
        attachmentLink
        hasParts
      }
      nextToken
    }
  }
`;

export const messagesByStaffId = /* GraphQL */ `
  query MessagesByStaffId(
    $staffId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    messagesByStaffId(
      staffId: $staffId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        staff {
          id
          firstName
          lastName
          status
        }
        createdAt
        channelType
        group
        staffId
        subject
        bodyText
        senderName
        smsStatus
        smsSendInformation
        deviceSmsSendInformation
        deviceSmsStatus
        emailStatus
        emailSendInformation
        inAppMessageStatus
        inAppMessageSendInformation
        phoneStatus
        phoneSendInformation
        isReadS
        sender {
          id
        }
        device {
          id
          deviceName
        } 
        messageType
        contentType
        attachment{
          id
          s3Key
          fileSize
          contentType
          expirationDate
          shortenUrl {
            items {
              id
              shortenId
            }
            nextToken
          }
        }
        attachmentLink
        hasParts
      }
      nextToken
    }
  }
`;

export const messagesByDeviceAssociateId = /* GraphQL */ `
  query MessagesByDeviceAssociateId(
    $deviceAssociateId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    messagesByDeviceAssociateId(
      deviceAssociateId: $deviceAssociateId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        staff {
          id
          firstName
          lastName
          status
        }
        createdAt
        channelType
        group
        staffId
        subject
        bodyText
        senderName
        smsStatus
        smsSendInformation
        deviceSmsSendInformation
        deviceSmsStatus
        destinationName
        isReadS
        sender {
          id
        }
        messageType
        contentType
        attachment{
          id
          s3Key
          fileSize
          contentType
          expirationDate
          shortenUrl {
            items {
              id
              shortenId
            }
            nextToken
          }
        }
        attachmentLink
        hasParts
      }
      nextToken
    }
  }
`;